import { render, staticRenderFns } from "./UserShowDetailsTab.vue?vue&type=template&id=46e869cc"
import script from "./UserShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./UserShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports